export default __webpack_public_path__ + "static/media/dredggg.9a755920.jpg";